module.exports = __webpack_public_path__ + "static/inside-bagnall-hill-studio_portrait.91d2a0e1.jpg";


//////////////////
// WEBPACK FOOTER
// /opt/build/repo/src/images/photos/inside-bagnall-hill-studio_portrait.jpg
// module id = 659
// module chunks = 0